import authService from '../services/auth';
import routes from '../constants/routes';
import routing from '../services/routing';

export default async () => {
    try {
        return await authService.getUserInfo();
    } catch (error) {
        if (error.message === 'USER_NOT_LOGGED_IN') {
            routing.push(routes.SIGN_IN);
        } else {
            throw error;
        }
    }
};
